var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewMenuBedandbreakfast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_508_4528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.13867 23.5H27.5137V29.125H3.13867",
    stroke: "#240b3b",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13867 23.5V17.875H6.88867C7.88323 17.875 8.83706 18.2701 9.54032 18.9734C10.2436 19.6766 10.6387 20.6305 10.6387 21.625V23.5",
    stroke: "#240b3b",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5762 23.5L12.8337 20.985C13.3008 20.0505 14.0189 19.2646 14.9075 18.7153C15.7962 18.166 16.8202 17.875 17.8649 17.875H23.7637C24.7582 17.875 25.712 18.2701 26.4153 18.9734C27.1185 19.6766 27.5137 20.6305 27.5137 21.625V23.5",
    stroke: "#240b3b",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13867 29.125V16",
    stroke: "#240b3b",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3255 5.85156C13.4179 5.85156 11.5884 6.60936 10.2395 7.95825C8.89063 9.30714 8.13281 11.1366 8.13281 13.0443H22.5182C22.5182 11.1366 21.7604 9.30714 20.4115 7.95825C19.0626 6.60936 17.2331 5.85156 15.3255 5.85156Z",
    stroke: "#240b3b",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3262 4.15234V5.85072",
    stroke: "#240b3b",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_508_4528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.326172 0.0625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMenuBedandbreakfast);
export default __webpack_public_path__ + "static/media/new-menu-bedandbreakfast.9b2c1481f0f232ad08b31c41130af311.svg";
export { ForwardRef as ReactComponent };